import { makeStyles, Theme } from '@material-ui/core';
import { CSSProperties } from 'react';

export const useStyles = makeStyles(({ custom, breakpoints }: Theme) => ({
  root: {
    maxWidth: 400,
    margin: 'auto 20px',
    top: 'auto',
    maxHeight: '96%',
    overflow: 'auto',
    scrollbarColor: 'light',
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: 6,
      height: 6,
      borderRadius: 6,
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#d0d5e1',
      borderRadius: 6,
    },
  },
  uiLiftRoot: {
    borderRadius: 16,
    width: 520,
    maxWidth: 520,
    padding: '32px 40px',
    [breakpoints.down(500)]: {
      padding: '32px 24px',
    },
  },
  rootIE11: {
    top: 100,
  },
  materialModalRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'unset',
  },
  materialModalRootHighZIndex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'unset',
    zIndex: '1303 !important' as CSSProperties['zIndex'],
  },
  title: {
    marginTop: 0,
    marginBottom: 26.56,
    fontSize: 32,
    fontFamily: 'Merriweather',
    color: custom.grey[3],
    textAlign: 'center',
  },
  footerCloseButton: {},
}));
